// extracted by mini-css-extract-plugin
export default {"addToWallet":"_0wjkC","ticketInfo":"tTRZr"};